
import { AllowancesType, Params } from 'app/dataTypes/allowances'
import { Request } from '../../index'



type ResultApi = Array<string>

export const convertResult = (apiData: ResultApi): AllowancesType => {
  return apiData
}

export type ApiParams = {
  dealer?: boolean,
  order_type?: 'cafeteria' | 'camp',
}

export const convertParams = (params: Params): [ApiParams, null] => {
  const {
    dealer,
    orderType,
  } = params
  return [{
    dealer,
    order_type: orderType,
  }, null]
}

export const GET_ALLOWANCES_LIST: Request<Params, AllowancesType, void> = [
  'food/allowances',
  'get',
  ['data', 'allowances'],
]
